import { readPath } from './readPath';
import { SDK_RESULT } from './sdkResult';

// gloss
const defaultIsError = (response: unknown): unknown => readPath(response, SDK_RESULT.error);

// gloss
export const assertPageOk = <R>(
  response: R,
  { label, page, isError }: { label: string; page: number; isError?: (response: R) => unknown },
): void => {
  const requestError = (isError ?? defaultIsError)(response);
  if (!requestError) return;
  const status = readPath(response, SDK_RESULT.status);
  const message = readPath(requestError, 'message');
  throw new Error(
    `${label}: page ${page} failed${status ? ` (${status})` : ''}${message !== undefined ? `: ${String(message)}` : ''}`,
  );
};
